/** Display label for route cards / fare tables — maps mid-tier names to customer-facing "SUV". */
export function formatVehicleTierLabel(name) {
  if (!name) return name;
  const normalized = name.trim();
  if (/^ertiga(\s*\/\s*muv)?$/i.test(normalized) || /^muv$/i.test(normalized)) {
    return 'SUV';
  }
  return normalized;
}
